/**
 * Product cards in authored content (article and page bodies).
 *
 * The author writes a plain link, `<a class="product-card"
 * href="/products/HANDLE">Name</a>`, alone or inside a
 * `<div class="product-row">`. Each link is replaced by the theme's
 * `card-product`, rendered by the `product-card` section through the
 * Section Rendering API, so the name, image and price are the product's
 * current ones in the visitor's language and currency. A link whose product
 * fails to load stays a plain link.
 */
(() => {
  const SECTION_ID = 'product-card';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function productHandle(link) {
    const match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/]+)/);
    return match ? match[1] : null;
  }

  async function upgrade(link) {
    const handle = productHandle(link);
    if (!handle) return;

    const url = new URL(`${root}products/${handle}`, window.location.origin);
    url.searchParams.set('section_id', SECTION_ID);

    let markup;
    try {
      const response = await fetch(url.toString());
      if (!response.ok) return;
      markup = await response.text();
    } catch (error) {
      console.error(`[content-products] Failed to load ${handle}:`, error);
      return;
    }

    // A missing product still answers 200, with an empty section.
    const card = new DOMParser()
      .parseFromString(markup, 'text/html')
      .querySelector(`#shopify-section-${SECTION_ID} .card-wrapper`);
    if (!card) return;

    const item = document.createElement('div');
    item.className = 'content-product';
    item.append(document.adoptNode(card));
    link.replaceWith(item);
  }

  for (const link of document.querySelectorAll('.rte a.product-card')) {
    upgrade(link);
  }
})();
